<app-dialog title="" [showDialog]="isShow" [size]="dialogSize.MEDIUM" [hasScroll]="false" [isClosable]="false" [isMaximizable]="false" [iconConfirmButton]="primeIcon.REFRESH" labelConfirmButton="Atualizar agora" [callbackConfirmButton]="callbackReload">
  <div class="version-update-content flex flex-column align-items-center">
    <div class="version-update-hero flex flex-column align-items-center">
      <div class="version-update-logo-wrapper">
        <app-branding class="version-update-logo" [variant]="brandingVariant.COLORFUL" [size]="brandingSize.FULL"></app-branding>
      </div>
    </div>
    <div class="version-update-body flex flex-column align-items-center gap-16">
      <h2 class="version-update-title font-lg-semi">Nova versão do Aurora disponível!</h2>
      <p class="version-update-description font-md-regular">Publicamos uma atualização com melhorias para você. Para continuar, basta recarregar a página... <b>leva só alguns segundos.</b></p>
    </div>
  </div>
</app-dialog>
